import { useTranslation as translation } from 'i18next-vue'

export function useTranslation() {
  return translation()
}
